import { render, staticRenderFns } from "./MatchField.vue?vue&type=template&id=06368c79&scoped=true&"
import script from "./MatchField.vue?vue&type=script&lang=js&"
export * from "./MatchField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06368c79",
  null
  
)

export default component.exports